// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3Ytk2","assignButton":"CreateEditEquipmentSchedule_assignButton__2RrX2"};